import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import SmoothScroll from "./components/SmoothScroll";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicLayout from "./components/layout/PublicLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Courses from "./pages/Courses";
import ProgramDetail from "./pages/ProgramDetail";
import Admissions from "./pages/Admissions";
import Fees from "./pages/Fees";
import Eligibility from "./pages/Eligibility";
import Placements from "./pages/Placements";
import LocationLanding from "./pages/LocationLanding";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AppRedirect from "./pages/AppRedirect";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <ScrollToTop />
            <Toaster position="top-center" richColors />
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/courses" element={<Courses />} />
                <Route path="/programs/:slug" element={<ProgramDetail />} />
                <Route path="/admissions" element={<Admissions />} />
                <Route path="/admissions/fees" element={<Fees />} />
                <Route path="/admissions/eligibility" element={<Eligibility />} />
                <Route path="/placements" element={<Placements />} />
                <Route path="/nursing-college-in-dhanbad" element={<LocationLanding city="dhanbad" />} />
                <Route path="/nursing-college-in-ranchi" element={<LocationLanding city="ranchi" />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/blog" element={<Blog />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/app" element={<AppRedirect />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
